// src/mutations/deleteArtworkMutation.js
import { gql } from "@apollo/client";

export const DELETE_ARTWORK_MUTATION = gql`
  mutation DeleteLibraryCard($tenantId: String!, $entityType: String!, $entityId: String!) {
    deleteLibraryCard(input: { tenantId: $tenantId, entityType: $entityType, entityId: $entityId }) {
      success
    }
  }
`;
